import * as React from 'react';
import { debounce } from 'lodash';
import { useFormState } from 'react-final-form';

type Props<T> = {
  delay: number;
  onChange: (values: T) => void;
};
/**
 * TODO -> Popis -> Modul pro vnitřek react-final-formu filtračních komponent, pro sledování změny na nějakém formulářovém prvku a následné odeslání celého formuláře
 * @param delay
 * @param onChange
 */
export function rffFormOnChangeListener<T>({ delay, onChange }: Props<T>) {
  const { values } = useFormState<T>();
  const isFirstRun = React.useRef(true);
  const debouncedOnChange = React.useCallback(debounce(onChange, delay), []);
  React.useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (delay > 0) {
      debouncedOnChange(values);
    } else {
      onChange(values);
    }
  }, [values]);
  return null;
}
rffFormOnChangeListener.defaultProps = {
  delay: 0,
};
